// Multivariate Dependencies
import React from 'react';
export var NumericInputStructure = function (_a) {
    var className = _a.className, placeholder = _a.placeholder, value = _a.value, _b = _a.state, state = _b === void 0 ? 'default' : _b, onChange = _a.onChange, onEnter = _a.onEnter, onBlur = _a.onBlur;
    var callOnEnterIfEnterPressed = function (event) {
        if (event.key === 'Enter') {
            onEnter();
        }
    };
    return (React.createElement("input", { className: className, disabled: state === 'disabled' || state === 'locked', placeholder: placeholder, value: value !== null && value !== void 0 ? value : '', onChange: function (event) {
            var inputValue = event.target.value;
            onChange(inputValue === '' ? undefined : Number(inputValue));
        }, onKeyDown: callOnEnterIfEnterPressed, onBlur: onBlur, type: 'number' }));
};
//# sourceMappingURL=NumericInputStructure.js.map